var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35394 15.5069C3.59794 16.8069 4.73394 17.7499 6.05694 17.7499H13.3979C14.3639 17.7499 15.1479 16.9659 15.1479 15.9999C15.1479 15.4269 15.1479 14.6869 15.1479 13.9999C15.1479 13.2709 14.8579 12.5709 14.3419 12.0549C13.8259 11.5399 13.1269 11.2499 12.3979 11.2499H8.23194C8.11094 11.2499 8.00794 11.1639 7.98594 11.0449L6.43394 2.50795C6.19594 1.19995 5.05694 0.249947 3.72794 0.249947C3.35094 0.249947 2.95694 0.249947 2.60194 0.249947C2.08194 0.249947 1.58794 0.481947 1.25594 0.881947C0.922941 1.28295 0.785941 1.81095 0.881941 2.32295L3.35394 15.5069ZM4.82894 15.2299L2.35694 2.04595C2.34294 1.97295 2.36294 1.89795 2.40994 1.83995C2.45794 1.78295 2.52794 1.74995 2.60194 1.74995H3.72794C4.33194 1.74995 4.84994 2.18195 4.95794 2.77595C5.39194 5.16495 6.18194 9.50795 6.50994 11.3129C6.66194 12.1449 7.38594 12.7499 8.23194 12.7499H12.3979C12.7289 12.7499 13.0469 12.8819 13.2809 13.1159C13.5159 13.3509 13.6479 13.6679 13.6479 13.9999V15.9999C13.6479 16.1379 13.5359 16.2499 13.3979 16.2499H6.05694C5.45594 16.2499 4.93994 15.8219 4.82894 15.2299Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26187 16.6028C7.26187 16.6028 6.42287 17.9428 5.71787 19.0718C5.38087 19.6118 5.36287 20.2918 5.67087 20.8478C5.97987 21.4048 6.56587 21.7498 7.20187 21.7498H13.8979C14.3109 21.7498 14.6479 21.4138 14.6479 20.9998C14.6479 20.5858 14.3109 20.2498 13.8979 20.2498H7.20187C7.11087 20.2498 7.02687 20.2008 6.98287 20.1208C6.93887 20.0418 6.94187 19.9448 6.98987 19.8668L8.53387 17.3968C8.75287 17.0458 8.64587 16.5828 8.29487 16.3638C7.94387 16.1448 7.48087 16.2508 7.26187 16.6028Z",
    fill: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89783 8.74995H12.8978C13.3108 8.74995 13.6478 8.41395 13.6478 7.99995C13.6478 7.58595 13.3108 7.24995 12.8978 7.24995H6.89783C6.48383 7.24995 6.14783 7.58595 6.14783 7.99995C6.14783 8.41395 6.48383 8.74995 6.89783 8.74995Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatIcon);
export default __webpack_public_path__ + "static/media/seat-icon.c6521fb7ba0619f44dff41b1a7e3554e.svg";
export { ForwardRef as ReactComponent };